import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

// Redirects a parent route to its default child route while preserving the
// current query string. A bare <Navigate to="child" /> drops search params,
// which breaks deep links such as /orders?orderId=123 — the redirect to
// /orders/list would lose orderId and the order modal would never open.
function IndexRedirect({ to }) {
  const location = useLocation()
  return <Navigate to={`${to}${location.search}`} replace />
}

export default IndexRedirect
